<!-- An image with a picture: the preview, opening full size in a new tab through the one open action (a chat file through a
     link minted then, B-19; ITP-E-240-10). -->
<a *ngIf="image && preview && !previewFailed; else notPreview" class="file-image" [href]="current.url || preview"
   target="_blank" rel="noopener noreferrer" [attr.aria-label]="'Open image ' + current.name" [matTooltip]="current.name"
   (click)="open($event)">
    <img [src]="preview" [alt]="current.name" loading="lazy" (error)="onPreviewError()">
</a>

<ng-template #notPreview>
    <!-- An image with no picture to draw (a fixture, or a chat file's still coming): carbon's tinted block, named. -->
    <span *ngIf="image && !preview && !previewFailed; else fileRow" class="file-image file-image--blank" role="img" [attr.aria-label]="current.name">
        <i class="fa-regular fa-image" aria-hidden="true"></i>
        <span class="file-image-caption">{{current.name}}</span>
    </span>
</ng-template>

<ng-template #fileRow>
    <!-- ITP-E-240-10: a file with an address (from the Drive, or before chat files) opens through the one open action, and its
         link reads as Details' does. -->
    <a *ngIf="current.url; else chatRow" class="file-row" [href]="current.url" target="_blank" rel="noopener noreferrer"
       [attr.aria-label]="'Download ' + current.name + (size ? ', ' + size : '')" (click)="open($event)">
        <ng-container *ngTemplateOutlet="rowBody"></ng-container>
    </a>
    <ng-template #chatRow>
        <!-- B-19 (ITP-E-207-07): a chat file names no link; its link is minted when it is opened. -->
        <button *ngIf="chatFile; else plainRow" type="button" class="file-row file-row--open" [disabled]="opening"
                [attr.aria-label]="(video ? 'Play ' : 'Open ') + current.name + (size ? ', ' + size : '')" (click)="open($event)">
            <ng-container *ngTemplateOutlet="rowBody"></ng-container>
        </button>
    </ng-template>
    <ng-template #plainRow>
        <span class="file-row" [attr.aria-label]="current.name + (size ? ', ' + size : '')">
            <ng-container *ngTemplateOutlet="rowBody"></ng-container>
        </span>
    </ng-template>
</ng-template>

<!-- B-19: a chat video plays here, from the link minted when it was opened. -->
<video *ngIf="playing" class="file-video" [src]="playing" controls autoplay preload="metadata"></video>
<span *ngIf="openFailed" class="file-note" role="status">This file can't be opened.</span>

<ng-template #rowBody>
    <span class="file-mark" aria-hidden="true">
        <i [ngClass]="mark.icon"></i>
        <span class="file-format">{{mark.format}}</span>
    </span>
    <span class="file-text">
        <span class="file-name" [matTooltip]="current.name">{{current.name}}</span>
        <span class="file-size" *ngIf="size">{{size}}</span>
    </span>
</ng-template>
